import React from 'react';
import { isFunction } from 'lodash';
import { PMPFormField, PMPPanelProps } from './utils';
import { useFormContext } from 'react-hook-form';
import StoredAccordion from 'src/components/StoredAccordion';
import { Grid, Header } from 'semantic-ui-react';
import { chunk } from 'lodash';
import { checkErrors } from './configs/config-utils';
import NDSectorFormField from './NDSectorFormField';

function NDSectorPanel(props: PMPPanelProps) {
  const { ap, choices, panel, sm } = props;
  const { getValues, setValue, getFieldState } = useFormContext();
  const errors = checkErrors({
    panel,
    getValues,
    getFieldState,
    ap,
    sm,
    setValue,
    choices,
  });

  let sectorElements;
  const {
    fieldLayout,
    name,
    title,
    show,
    customClass,
    sectorTitles = ['Sector 1', 'Sector 2'],
  } = panel;
  let fields = panel.fields;
  if (show && !show({ formGetter: getValues, choices, ap })) return <></>;
  // hack to incorporate the number of component carriers field on
  // first row (even before the headers)
  const radioQty = fields.filter((field) => {
    return field.attrName === 'radio_qty';
  })[0];
  fields = fields.filter((field) => {
    return field.attrName !== 'radio_qty';
  });
  if (fieldLayout) {
    sectorElements = fieldLayout.map((row, i) => {
      if (row.length === 1) {
        return (
          <div style={{ width: '100%', marginBottom: '10px' }} key={i}>
            <NDSectorFormField
              key={fields[row[0]]['attrName']}
              field={fields[row[0]]}
              {...props}
            ></NDSectorFormField>
          </div>
        );
      } else {
        return (
          <Grid.Row key={i} columns={row.length} centered>
            {row.map((colIndex, j) => {
              const field = fields[colIndex];
              return (
                <Grid.Column key={`${field.attrName}-${j}`}>
                  <NDSectorFormField
                    field={field}
                    {...props}
                  ></NDSectorFormField>
                </Grid.Column>
              );
            })}
          </Grid.Row>
        );
      }
    });
  } else {
    const chunkedFields = chunk(fields, 2);
    sectorElements = chunkedFields.map((fieldChunk: any, i) => {
      return (
        <Grid.Row key={i} columns={2}>
          {fieldChunk.map((field: PMPFormField, j) => {
            return (
              <Grid.Column key={`${field.attrName}-${j}`}>
                <NDSectorFormField field={field} {...props}></NDSectorFormField>
              </Grid.Column>
            );
          })}
        </Grid.Row>
      );
    });
  }

  let titles = sectorTitles;
  if (isFunction(sectorTitles)) {
    titles = sectorTitles({ formGetter: getValues });
  }

  return (
    <StoredAccordion
      name={`nd_${name}`}
      title={title}
      className={customClass}
      headerClass={errors ? 'custom-error' : ''}
      contentProps={{ loading: ap.dirty || sm?.dirty }}
    >
      {radioQty && (
        <NDSectorFormField field={radioQty} {...props}></NDSectorFormField>
      )}
      <Grid columns={2}>
        {titles && titles.length >= 2 && (
          <Grid.Row>
            <Grid.Column>
              {titles[0] && (
                <Header as="h5" textAlign="center">
                  {titles[0].split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </Header>
              )}
            </Grid.Column>
            <Grid.Column>
              {titles[1] && (
                <Header as="h5" textAlign="center">
                  {titles[1].split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </Header>
              )}
            </Grid.Column>
          </Grid.Row>
        )}
        {sectorElements}
      </Grid>
    </StoredAccordion>
  );
}

export default NDSectorPanel;
